import type {
  TableExplorerApplyChangesRequest,
  TableExplorerApplyChangesResult,
  TableExplorerFetchCellValueRequest,
  TableExplorerFetchCellValueResult,
  TableExplorerFetchInboundForeignKeysRequest,
  TableExplorerFetchInboundForeignKeysResult,
  TableExplorerFetchRowsRequest,
  TableExplorerFetchRowsResult,
  TableExplorerPreviewChangesRequest,
  TableExplorerPreviewChangesResult,
  TableExplorerPreviewSelectRequest,
  TableExplorerPreviewSelectResult,
} from '../../../../types/tableExplorer';
import { useAppStore } from '../../../../store/appStore';

function getTableExplorerApi() {
  const api = window.electronAPI?.tableExplorer;
  if (!api) {
    throw new Error('Electron Table Explorer API is not available');
  }
  return api;
}

/**
 * The user's query-timeout setting, as milliseconds (0 = no timeout).
 * Table Explorer requests carry it so the engine adapter enforces the same
 * bound as Query Editor runs (the pools have no driver-level timeout).
 */
function currentQueryTimeoutMs(): number {
  return useAppStore.getState().queryExecutionSettings.timeoutSeconds * 1000;
}

export async function fetchTableExplorerRows(
  request: TableExplorerFetchRowsRequest
): Promise<TableExplorerFetchRowsResult> {
  return getTableExplorerApi().fetchRows({ timeoutMs: currentQueryTimeoutMs(), ...request });
}

export async function previewTableExplorerSelect(
  request: TableExplorerPreviewSelectRequest
): Promise<TableExplorerPreviewSelectResult> {
  return getTableExplorerApi().previewSelect(request);
}

export async function previewTableExplorerChanges(
  request: TableExplorerPreviewChangesRequest
): Promise<TableExplorerPreviewChangesResult> {
  return getTableExplorerApi().previewChanges(request);
}

export async function applyTableExplorerChanges(
  request: TableExplorerApplyChangesRequest
): Promise<TableExplorerApplyChangesResult> {
  return getTableExplorerApi().applyChanges({ timeoutMs: currentQueryTimeoutMs(), ...request });
}

export async function fetchTableExplorerInboundForeignKeys(
  request: TableExplorerFetchInboundForeignKeysRequest
): Promise<TableExplorerFetchInboundForeignKeysResult> {
  return getTableExplorerApi().fetchInboundForeignKeys(request);
}

export async function fetchTableExplorerCellValue(
  request: TableExplorerFetchCellValueRequest
): Promise<TableExplorerFetchCellValueResult> {
  return getTableExplorerApi().fetchCellValue(request);
}
